import { phpRequest } from "./phpRequest";
import localforage from 'localforage';
// 应用程序相关API
const ApplicationProgramApi = {
  // 获取exe包信息
  getWindowsInfo : (data) => {
    const formData = new FormData();
    if(Object.keys(data).length>0){
      for(var key in data) {
        formData.append(key,data[key])
      }
    }
    return phpRequest.post('/drive/file/get-version',data,{
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 1000 * 60
    })
  }
}
export default ApplicationProgramApi
